module.exports = __webpack_public_path__ + "img/cmbs-data-performance.fc06090e.svg";